import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const CustomTabsStyles = makeStyles()((theme: Theme) => ({
  checkboxStyles: {
    color: 'green',
    '&.Mui-checked': {
      color: 'green',
    },
    '&.Mui-disabled': {
      color: '#bfbfbf',
    },
  },

  tabStyles: {
    "& .MuiTab-root": {
      color: "#000",
    },
    "& .Mui-selected": {
      color: "#3B78CE",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "#3B78CE",
      borderRadius: "5px 5px 0px 0px",
    }
  }
}));
export default CustomTabsStyles;